import bindAllOfThis from 'src/utils/BindThisHelper';
import { PhaserModal, PhaserModalConfig } from 'src/games/shared/Modal';
import TranslateApi from '../../../utils/TranslateHelper';
import { PhaserButtonConfig } from 'src/games/shared/Button';
import { Color } from 'src/games/shared/ColorValue';
import { EndGameScene } from './EndGameScene';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { SeekCard, SeekItem } from '../objects/SeekItem';
import { runInThisContext } from 'vm';

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    map: Phaser.Tilemaps.Tilemap;

    cards: SeekCard[];
    items: SeekItem[];

    constructor() {
        super({
            key: "MainScene"
        });
    }

    preload(): void {
        this.load.tilemapTiledJSON("map", require("src/assets/qci/maps/seek_and_find.json"));
        this.load.image("background", require("src/assets/qci/backgrounds/1s_background.jpg"));
        this.load.atlas("assets", require("src/assets/qci/atlas/gameSeekAndFind.png"), require("src/assets/qci/atlas/gameSeekAndFind.json"));
    }

    initialize() {
        bindAllOfThis(this, MainScene.prototype);
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: "map" });
        this.cards = [];
        this.items = [];
    }

    create(): void {
        this.initialize();
        var background = this.add.sprite(0, 0, "background", 0).setOrigin(0);
        this.createScene();
        this.registerEvents();
    }

    registerEvents() {
        // Prevents dragstart from acting like pointerdown
        this.input.dragDistanceThreshold = 5;

        this.input.on('dragstart', (pointer: Phaser.Input.Pointer, card: SeekCard) => {
            card.x = pointer.downX;
            card.y = pointer.downY;
            this.children.bringToTop(card);
            card.setScale(0.3);
        });

        this.input.on('drag', (pointer: Phaser.Input.Pointer, card: SeekCard, dragX: number, dragY: number) => {
            card.x = pointer.x;
            card.y = pointer.y;
        });

        this.input.on('dragend', (pointer: Phaser.Input.Pointer, card: SeekCard, dropped: boolean) => {
            this.children.moveDown(card);
            if (!dropped) {
                this.putCardBack(card);
            }
        });

        this.input.on('drop', (pointer, card: SeekCard, zone: SeekItem) => {
            if (card.id === zone.id) {
                this.dropCard(card, zone);
            }
            else {
                this.putCardBack(card);
            }
        });
    }

    dropCard(card: SeekCard, zone: SeekItem) {
        card.setVisible(false);
        zone.found = true;
        zone.overlay.setVisible(false);
        this.checkGameEnd();
    }

    putCardBack(card: SeekCard) {
        card.setScale(1);
        card.setPosition(card.position.x, card.position.y);
    }

    createScene() {
        this.map.getObjectLayer("Scene").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "tray") {
                var tray = this.add.sprite(ob.x, ob.y, "pixel");
                tray.setDepth(1);
                tray.setOrigin(0);
                tray.setDisplaySize(ob.width, ob.height);
                tray.setTint(0).setAlpha(0.9);
            }
            else if (ob.type === "SeekCard") {
                var seekCard = new SeekCard(this, ob);
                this.cards.push(seekCard);
            }
            else if (ob.type === "SeekItem") {
                var seekItem = new SeekItem(this, ob);
                seekItem.overlay = this.add.image(0, 0, "assets", "overlay" + ob.properties["id"]).setOrigin(0);
                this.items.push(seekItem);
            }
        });
    }

    modal(translationKey: string) {
        var text = TranslateApi.translate(translationKey);
        var buttonConfig: PhaserButtonConfig = {
            smartSize: true,
            backgroundColor: Color.KUDER_PRIMARY_BUTTON
        };

        var config: PhaserModalConfig = {
            title: text,
            buttonWidth: 200,
            buttonConfig: buttonConfig
        };

        var buttonText = TranslateApi.translate("common.ok");
        var options = [{ id: 1, displayText: buttonText }];
        var modal = new PhaserModal(this, 0, 0, options, config);
        modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
        modal.on("optionClicked", () => {
            modal.destroy();
        });
    }


    endGame(): void {
        this.input.setDefaultCursor("default");
        this.input.enabled = false;
        this.scene.add("EndGameScene", EndGameScene, true);
        this.scene.remove(this);
    }

    checkGameEnd() {
        for (var i of this.items) {
            if (!i.found) {
                return false;
            }
        }

        setTimeout(() => {
            this.endGame();
        }, 1000);
    }
}



// WEBPACK FOOTER //
// ./src/games/SeekAndFindGame/scenes/MainScene.ts